// redux/slices/slotSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialSlotsState = {
  selectedSlot: null, // store selected date & time here
};

const slotSlice = createSlice({
  name: "slots",
  initialState: initialSlotsState,
  reducers: {
    setSelectedSlot: (state, action) => {
      state.selectedSlot = action.payload; // e.g., { date: '2025-07-10', time: '10:00 AM' }
    },
    clearSelectedSlot: (state) => {
      state.selectedSlot = null;
    },
  },
});

export const { setSelectedSlot, clearSelectedSlot } = slotSlice.actions;
export default slotSlice.reducer;
